export default [
    
    {
        path:'/',
        component:  () => import("../views/app/indicadores/Indicadores.vue")
    },
    {
        path:'kpiList',
        component:  () => import("../views/app/indicadores/Kpi.vue")
    },
    {
        path:'tipo',
        component:  () => import("../views/app/indicadores/ListStereotype.vue")
    },
    {
        path:'*',
        component:  () => import("../views/app/indicadores/Indicadores.vue")
    },

]